<div fxLayout="column" fxLayoutAlign="start stretch" *ngIf="SelectedCollege && SelectedCollege.Term && AgreementChecks">
    <h2 class="mat-title">
        Terms &amp; Conditions for Dual Enrollment - {{ SelectedCollege.CollegeName }} -
        {{ SelectedCollege.Term.TermCode | collegeTerm }} Term {{ SelectedCollege.SchoolYear | schoolYear }}
    </h2>
    <div style="align-self: stretch" *ngIf="!StudentPolkAgreementApproved && !AsParent">
        <p>
            No agreement is on file for the {{ SelectedCollege.Term.TermCode | collegeTerm }} Term for
            {{ SelectedCollege.CollegeName }}. Please review the terms and agreements for both your selected college and the Polk
            County School District in the tabs below, and then use the checkboxes at the bottom to indicate your consent to the terms.
            This step must be completed before the dual enrollment system can be accessed for this college and term.
        </p>
    </div>
    <div style="align-self: stretch" *ngIf="!StudentPolkAgreementApproved && AsParent">
        <p>
            No parent agreement is on file for the {{ SelectedCollege.Term.TermCode | collegeTerm }} Term for
            {{ SelectedCollege.CollegeName }}. Please review the terms and agreements for both your student's selected college and the
            Polk County School District in the tabs below, and then use the checkboxes at the bottom to indicate your consent to the
            terms. This step must be completed before the student can participate in the dual enrollment program for this college and
            term.
        </p>
    </div>
    <mat-tab-group [dynamicHeight]="true">
        <mat-tab label="Polk County School District">
            <div>
                <h2 class="mat-title">Drafted {{ PCSBAgreementDate | datefns: 'MMM. D, YYYY' }}</h2>
                <div [innerHTML]="PCSBAgreementText | safeHTML"></div>
                <mat-checkbox
                    *ngIf="
                        !AsParent ||
                        (SelectedCollege.ParentHasApproved === true && SelectedCollege.ParentApprovedUser === User?.UserID) ||
                        !SelectedCollege.ParentHasApproved
                    "
                    [(ngModel)]="AgreementChecks.PCSBAgreed"
                    aria-label="Polk County School District Agreement Checkbox"
                    [disabled]="
                        (!AsParent && SelectedCollege.StudentPolkAgreementApproved === true) ||
                        (AsParent && SelectedCollege.ParentHasApproved === true)
                    "
                    >{{ PCSBAgreementConsentText }}
                    <span *ngIf="AsParent"
                        >I support my student's decision and understand the rights, responsibilities, and implications of this
                        selection.</span
                    ></mat-checkbox
                >
                <div *ngIf="!AsParent && SelectedCollege.StudentPolkAgreementApproved === true" style="margin-top: 15px">
                    <strong>Approved by student.</strong>
                </div>
                <div
                    *ngIf="
                        AsParent && SelectedCollege.ParentHasApproved === true && SelectedCollege.ParentApprovedUser === User?.UserID
                    "
                    style="margin-top: 15px"
                >
                    <strong>Approved on {{ SelectedCollege.ParentApprovedDate | datefns: 'MM/DD/YYYY' }}</strong>
                </div>
            </div>
        </mat-tab>
        <mat-tab [label]="SelectedCollege.CollegeName">
            <div>
                <h2 class="mat-title">Drafted {{ SelectedCollege.AgreementTextDate | datefns: 'MMM. D, YYYY' }}</h2>
                <div [innerHTML]="SelectedCollege.AgreementText | safeHTML"></div>
                <mat-checkbox
                    *ngIf="
                        !AsParent ||
                        (SelectedCollege.ParentHasApproved === true && SelectedCollege.ParentApprovedUser === User?.UserID) ||
                        !SelectedCollege.ParentHasApproved
                    "
                    [(ngModel)]="AgreementChecks.CollegeAgreed"
                    [aria-label]="SelectedCollege.CollegeName + ' Agreement Checkbox'"
                    [disabled]="
                        (!AsParent && SelectedCollege.StudentCollegeAgreementApproved === true) ||
                        (AsParent && SelectedCollege.ParentHasApproved)
                    "
                    >{{ SelectedCollege.AgreementConsentText }}</mat-checkbox
                >
                <div *ngIf="!AsParent && SelectedCollege.StudentCollegeAgreementApproved === true" style="margin-top: 15px">
                    <strong>Approved by student.</strong>
                </div>
                <div
                    *ngIf="
                        AsParent && SelectedCollege.ParentHasApproved === true && SelectedCollege.ParentApprovedUser === User?.UserID
                    "
                    style="margin-top: 15px"
                >
                    <strong>Approved on {{ SelectedCollege.ParentApprovedDate | datefns: 'MM/DD/YYYY' }}</strong>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <hr />
    <div
        class="mat-caption"
        *ngIf="
            SelectedCollege &&
            ((!AsParent && (SelectedCollege.StudentCollegeAgreementApproved == false || StudentPolkAgreementApproved == false)) ||
                (AsParent && (SelectedCollege.ParentHasApproved !== true || SelectedCollege.ParentApprovedUser === User?.UserID)))
        "
    >
        <em
            >{{ (AgreementChecks.PCSBAgreed === true ? 1 : 0) + (AgreementChecks.CollegeAgreed === true ? 1 : 0) }} of 2 agreements
            completed.</em
        >
    </div>
    <div
        fxLayout="row"
        fxLayoutAlign="start start"
        *ngIf="
            SelectedCollege &&
            ((!AsParent && (SelectedCollege.StudentCollegeAgreementApproved == false || StudentPolkAgreementApproved == false)) ||
                (AsParent && SelectedCollege.ParentHasApproved !== true))
        "
    >
        <button
            mat-raised-button
            color="primary"
            aria-label="Submit Approval"
            (click)="SubmitApproval()"
            [disabled]="AgreementChecks.PCSBAgreed == false || AgreementChecks.CollegeAgreed == false"
        >
            Submit Approval
        </button>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/ui/agreements/agreements.component.html